import UploadImage from "@components/UploadImage";
import { useAppSelector } from "@hooks/redux";
import { useFullServiceDisplay } from "@hooks/useFullServiceDisplay";
import { twMerge } from "tailwind-merge";

interface FullServiceProps {
  isFullService?: boolean;
  className?: string;
}

export default function FullService({ isFullService, className }: FullServiceProps) {
  const { language } = useAppSelector((state) => state.globalReducer);
  const { isShowFullService } = useFullServiceDisplay();

  if (isShowFullService && isFullService) {
    if (language === "zh-CN" || language === "en-US") {
      return (
        <div
          className={twMerge(
            "absolute top-0 left-0 bg-[#FF69B4] h-[16px] px-[3px] flex items-center justify-center rounded-tl-[4px] rounded-br-[4px] text-white text-[9px] whitespace-nowrap",
            className,
          )}
        >
          {language === "zh-CN" ? "全托管" : "Full Service"}
        </div>
      );
    } else {
      return <UploadImage name="971a6de0.png" className={"w-[16px] h-[16px] absolute top-0 left-0"}></UploadImage>;
    }
  }
  return null;
}
